import cn from 'classnames';
import styles from './styles.module.scss';

interface CurriculumRowProps {
  Tag: 'td' | 'th';
  row: any;
  isFirstRow?: boolean;
}

const isNumeric = (value: unknown): boolean => {
  if (typeof value === 'number') {
    return Number.isFinite(value);
  }

  return typeof value === 'string' && value.trim() !== '' && Number.isFinite(Number(value));
};

export const CurriculumRow = ({ Tag, row, isFirstRow }: CurriculumRowProps) => {
  return (
    <tr>
      {row.cells?.map((cell: any, index: number) => {
        const textColumnClassName = isFirstRow && index <= 1 && styles.textColumn;
        const parentCellForGradesClassName =
          isFirstRow && cell.colSpan > 1 && styles.parentCellForGrades;

        return (
          <Tag
            colSpan={cell.colSpan || 1}
            rowSpan={cell.rowSpan || 1}
            key={cell.id}
            className={cn(
              styles.cell,
              cell.bold && styles.boldCell,
              textColumnClassName,
              parentCellForGradesClassName,
              isNumeric(cell.value) && styles.center,
            )}
          >
            {cell.value}
          </Tag>
        );
      })}
    </tr>
  );
};
